/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col, Row} from "react-bootstrap";


type FormFieldsGroupHeaderProps = {
    headerText: string,
    headerLabel?: string | null,
    children?: | React.ReactChild | React.ReactChild[];
    cssClasses?: string
};


export const FormFieldsGroupHeaderComponent: React.FC<FormFieldsGroupHeaderProps> = ({
    headerText,
    headerLabel = null,
    children = null,
    cssClasses = ""
}): JSX.Element => {


    cssClasses = (cssClasses ? `${cssClasses} ` : "") + "form-fields-group-header-component";


    return (
        <Row className={cssClasses}>

            {!!headerLabel &&
            <Col xs={12} className={"form-fields-group-header-label"}>
                <span>{headerLabel}</span>
            </Col>
            }

            <Col xs={12} className={"form-fields-group-header"}>
                <h2 className={`form-fields-group-heading`}>
                    <span>{headerText}</span>
                </h2>
            </Col>

            {!!children &&
	        <Col xs={12} className={"form-fields-group-header-extra-content"}>
                {children}
	        </Col>
            }

        </Row>
    );

};


export default FormFieldsGroupHeaderComponent;
